<template>
    <div class="setting-box">
        <div class="setting-title">选项设置</div>
        <div class="setting-content">
            <div class="setting-content-item">
                <div>上传文件数量</div>
                <div class="type-box">
                    <el-select v-model="dataList.fileNumber" class="m-2" style="width: 100%; height: 35px" placeholder="Select" size="large">
                        <el-option v-for="item in numberList" :key="item.value" :label="item.label" :value="item.value" />
                    </el-select>
                </div>
            </div>
            <div class="setting-content-item">
                <div>单个文件大小</div>
                <div class="type-box">
                    <el-select v-model="dataList.fileSize" class="m-2" style="width: 100%; height: 35px" placeholder="Select" size="large">
                        <el-option v-for="item in sizeList" :key="item.value" :label="item.label" :value="item.value" />
                    </el-select>
                </div>
            </div>
            <div class="setting-content-item">
                <div>文件格式</div>
                <div class="type-box">
                    <el-select v-model="dataList.fileFormat" class="m-2" style="width: 100%; height: 35px" placeholder="Select" size="large">
                        <el-option v-for="item in formatList" :key="item.value" :label="item.label" :value="item.value" />
                    </el-select>
                </div>
            </div>
        </div>
    </div>
</template>
<script setup name="kr-file-upload-setting">
const props = defineProps({
    dataList: {
        type: Object,
        default: () => ({}),
    },
});

const numberList = [
    { label: "1", value: "1" },
    { label: "2", value: "2" },
    { label: "3", value: "3" },
    { label: "4", value: "4" },
    { label: "5", value: "5" },
    { label: "6", value: "6" },
    { label: "7", value: "7" },
    { label: "8", value: "8" },
    { label: "9", value: "9" },
    { label: "10", value: "10" },
];
const sizeList = [
    { label: "5M", value: "5" },
    { label: "10M", value: "10" },
    { label: "15M", value: "15" },
    { label: "20M", value: "20" },
    { label: "25M", value: "25" },
    { label: "30M", value: "30" },
];
const formatList = [
    { label: "不限制", value: "" },
    { label: "图片", value: "P" },
    { label: "视频", value: "V" },
    { label: "音频", value: "A" },
];
</script>
<style lang="scss" scoped>
@import "@/css/setting.scss";
:deep(.el-radio) {
    margin-right: 60px;
}
:deep(.el-input-number) {
    width: 98px;
}
.type-box {
    display: flex;
    margin-top: 8px;
    .type-box1 {
        width: 98px;
        height: 35px;
        line-height: 35px;
        text-align: center;
        opacity: 1;
        border-radius: 4px;
        background: rgba(255, 255, 255, 1);
        border: 1px solid rgba(229, 232, 238, 1);
        cursor: pointer;
        &:first-child {
            margin-right: 30px;
        }
    }
}

::deep(.el-select--large) {
    width: 230px;
    position: relative;
}
:deep(.el-select-dropdown__item) {
    line-height: 44px;
}
</style>
